export const STATIC_ROUTER_PATH = {
  HOME: '/',
  ABOUTME: '/aboutme',
}
